module.exports = __webpack_public_path__ + "img/CS-Profi2013-Repairing.2f0c2a3a.jpg";